import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import Link from 'components/common/A'
import NowrapDiv from 'components/common/NowrapDiv'

import { useServiceClassifications } from 'utils/api/hooks'

const DEFAULT_SERVICELOGO = '/img/default_service_icon.svg'

const ContentWrapper = styled(Box)`
  ${({ theme }) => `
    width: 100%;
    background-color: ${theme.palette.background.gray};
    padding: 24px 16px 48px 16px;
    margin-bottom: 48px;

    ${theme.breakpoints.up('md')} {
      padding-left: 0px;
      padding-right: 0px;
      margin-bottom: 72px;
    }
  `}
`

const PopularServiceLayoutWrapper = styled(Box)`
  ${({ theme }) => `
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  justify-content: space-between;

    ${theme.breakpoints.up('md')} {
      width: 704px;
      maxwidth: 704px;
    }

    ${theme.breakpoints.up('lg')} {
      width: 770px;
      maxwidth: 770px;
    }

    ${theme.breakpoints.up('xl')} {
      width: 916px;
      maxwidth: 916px;
    }

    ${theme.breakpoints.up('xxl')} {
      width: 1222px;
      maxwidth: 1222px;
    }
  `}
`

const PopularServiceCardSection = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

const PopularServiceCardContent = styled(Link)`
  ${({ theme, $isMargin }) => `
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    margin-bottom: ${$isMargin ? '24px' : '0'};

    ${theme.breakpoints.up('md')} {
      width: 10%;
    }
  `}
`

const ServiceCardImageWrapper = styled(Box)`
  ${({ $hovered }) => `
    position: relative;
    margin-bottom: 12px;
    transform: ${$hovered ? 'translate(0, -8px)' : 'translate(0, 0)'};
    transition: all 0.2s ease-in-out;
  `}
`

const PopularServiceCardImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: cover;
`

const HoverCardPoint = styled(Box)`
  ${({ theme, $hovered }) => `
    height: 4px;
    width: 4px;
    border-radius: 50%;
    background-color: ${$hovered ? theme.palette.primary.main : 'transparent'};
    position: absolute;
    left: 50%;
    bottom: -8px;
    transform: translate(-50%, 0);
  `}
`

const PopularServiceCard = ({ classificationItem, isMargin }) => {
  const [hovered, setHovered] = useState(false)
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <PopularServiceCardContent
      $isMargin={isMargin}
      href={`/service/${classificationItem?.identityCode}`}
      $origin
      onMouseEnter={() => isDesktop && setHovered(true)}
      onMouseLeave={() => isDesktop && setHovered(false)}
    >
      <ServiceCardImageWrapper $hovered={hovered}>
        <PopularServiceCardImage
          src={classificationItem?.entranceIcon?.url || DEFAULT_SERVICELOGO}
        />
        <HoverCardPoint $hovered={hovered} />
      </ServiceCardImageWrapper>
      <Typography variant="label" color="textMinus2">
        <NowrapDiv $lines={2} $textCenter={true}>
          {classificationItem?.name || ''}
        </NowrapDiv>
      </Typography>
    </PopularServiceCardContent>
  )
}

const PopularServiceLayout = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const { data: classifications } = useServiceClassifications({
    displayVisible: 'visible',
    filterByServicesExists: true,
  })

  return (
    <ContentWrapper>
      <PopularServiceLayoutWrapper>
        <Box width="100%" borderBottom="1px solid #D4D4D4" mb={6}>
          <Typography
            mb={4}
            variant="label"
            color="textMinus2"
            fontWeight="bold"
            sx={{ whiteSpace: 'nowrap' }}
          >
            熱門服務
          </Typography>
        </Box>
        {isMobile ? (
          <>
            <PopularServiceCardSection>
              {classifications?.slice(0, 4)?.map((item, index) => {
                return (
                  <PopularServiceCard
                    key={index}
                    classificationItem={item}
                    isMargin
                  />
                )
              })}
            </PopularServiceCardSection>
            <PopularServiceCardSection>
              {classifications?.slice(4, 8)?.map((item, index) => {
                return (
                  <PopularServiceCard key={index} classificationItem={item} />
                )
              })}
            </PopularServiceCardSection>
          </>
        ) : (
          <PopularServiceCardSection>
            {classifications?.slice(0, 8)?.map((item, index) => {
              return (
                <PopularServiceCard key={index} classificationItem={item} />
              )
            })}
          </PopularServiceCardSection>
        )}
      </PopularServiceLayoutWrapper>
    </ContentWrapper>
  )
}

export default PopularServiceLayout
